export default `
  query getUserOrgFootprint($userId: String!) {
    getUserOrgFootprint(userId: $userId) {
      orgId
      orgName
      role
      memberCount
      isSoleOwner
    }
  }
`
